import React from "react"

function Logout({ width, height, color }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 21"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.48158 3.83377C4.90894 4.26916 4.90244 4.96855 4.46706 5.39592C3.0777 6.75967 2.2093 8.68253 2.2093 10.8205C2.2093 14.9869 5.49868 18.3183 9.5 18.3183C13.5013 18.3183 16.7907 14.9869 16.7907 10.8205C16.7907 8.68253 15.9223 6.75967 14.5329 5.39592C14.0976 4.96855 14.0911 4.26916 14.5184 3.83377C14.9458 3.39839 15.6452 3.39188 16.0806 3.81925C17.8818 5.58725 19 8.07367 19 10.8205C19 16.156 14.7719 20.5276 9.5 20.5276C4.22807 20.5276 0 16.156 0 10.8205C0 8.07367 1.11825 5.58725 2.91944 3.81925C3.35482 3.39188 4.05422 3.39839 4.48158 3.83377Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.67496 0.53418C10.285 0.53418 10.7796 1.02875 10.7796 1.63883V9.54034C10.7796 10.1504 10.285 10.645 9.67496 10.645C9.06488 10.645 8.57031 10.1504 8.57031 9.54034V1.63883C8.57031 1.02875 9.06488 0.53418 9.67496 0.53418Z"
        fill={color}
      />
    </svg>
  )
}

export default Logout
